import React from 'react';
import { Link } from 'react-router-dom';
import { ArrowLeft, MessageSquare } from 'lucide-react';

const ContactPage = () => {
  return (
    <div className="min-h-screen bg-bg-base py-12 px-6">
      <div className="max-w-3xl mx-auto">
        <Link to="/" className="inline-flex items-center gap-2 text-text-secondary hover:text-gold transition-colors mb-8">
          <ArrowLeft size={20} />
          Back to Home
        </Link>

        <div className="bg-bg-surface rounded-2xl p-8 lg:p-12 shadow-sm border border-border text-center">
          <div className="w-16 h-16 bg-gold-light rounded-2xl flex items-center justify-center mx-auto mb-6">
            <MessageSquare size={28} className="text-gold" />
          </div>

          <h1 className="font-display text-4xl font-bold text-text-primary mb-4">Contact & Feedback</h1>

          <p className="text-text-secondary text-lg leading-relaxed max-w-lg mx-auto mb-8">
            We&apos;re working on a feedback form to make it easy to share your thoughts, report bugs, and suggest features. Check back soon!
          </p>

          <div className="bg-gold-light/20 rounded-xl p-6 border border-gold/20 max-w-md mx-auto">
            <p className="text-text-secondary text-sm">
              In the meantime, you can reach us at:
            </p>
            <p className="text-gold font-medium mt-2">support@daypop.online</p>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ContactPage;
